const FIELD_LABELS = {
    firstname: 'First name',
    lastname: 'Last name',
    email: 'Email',
    password: 'Password',
    specialityId: 'Rotation/Experience',
    institutionId: 'Institution',
    rank: 'Rank',
    phone: 'Phone',
    address: 'Address',
    id_number: 'QID number',
    id_expiry_date: 'QID Expiry Date',
    iban: 'IBAN number'
};

const getFieldLabel = (rawField) => {
    if (!rawField) {
        return 'required field';
    }
    return FIELD_LABELS[rawField] || rawField;
};

export const formatApiError = (error, fallback = 'Request failed. Please try again.') => {
    if (error?.code === 'ERR_NETWORK') {
        return 'Cannot reach the server. Please check your internet connection.';
    }

    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;

    if (status === 422 && Array.isArray(detail) && detail.length > 0) {
        const first = detail[0];
        const field = Array.isArray(first?.loc) ? first.loc[first.loc.length - 1] : null;
        const msg = first?.msg || 'Invalid value';
        const fieldLabel = getFieldLabel(field);

        if (msg.toLowerCase().includes('field required')) {
            return `${fieldLabel} is required.`;
        }

        return `${fieldLabel}: ${msg}`;
    }

    if (typeof detail === 'string' && detail.trim()) {
        return detail;
    }

    if (Array.isArray(detail) && detail.length > 0) {
        const firstMsg = detail[0]?.msg;
        if (firstMsg) {
            return firstMsg;
        }
    }

    return fallback;
};
